import { z } from "zod";
import { BladeCommonSchema } from "../common";
export const SeparatorTypeSchema = z.nativeEnum({
    SIMPLE: "simple",
    ORNAMENTAL: "ornamental",
});
export const SeparatorSizeSchema = z.nativeEnum({
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large",
});
export const SeparatorType = SeparatorTypeSchema.enum;
export const SeparatorSize = SeparatorSizeSchema.enum;
export const SeparatorSchema = BladeCommonSchema.extend({
    separatorType: z.union([z.literal(SeparatorType.SIMPLE), z.literal(SeparatorType.ORNAMENTAL)]).optional(),
    size: z
        .union([z.literal(SeparatorSize.SMALL), z.literal(SeparatorSize.MEDIUM), z.literal(SeparatorSize.LARGE)])
        .optional(),
});
export const SeparatorBladeTypeValues = ["separator"];
export const SeparatorBladeTypesSchema = z.enum(SeparatorBladeTypeValues);
export const SeparatorBladeTypes = SeparatorBladeTypesSchema.enum;
export const SeparatorBladesContractSchema = SeparatorSchema.extend({
    type: SeparatorBladeTypesSchema,
});
export const SeparatorContractSchema = SeparatorSchema.extend({
    type: z.literal(SeparatorBladeTypes.separator),
});
//# sourceMappingURL=index.js.map